<template>
  <div>
    <div class="d-flex" style="overflow-x:auto">
      <template v-if="products.length">
        <router-link
          v-for="itemProd in products"
          :key="itemProd.INDEX"
          :to="{
            name: 'product-calculator',
            params: { kode: itemProd.ID },
            query: {index:itemProd.INDEX }
          }"
          class="d-flex text-body"
        >
          <div
            class="py-1 d-flex mr-1"
          >
            <b-avatar rounded size="40" :variant="$route.query.index == itemProd.INDEX ? 'danger' : 'light-danger'" class="mr-50">
              <feather-icon size="16" icon="ShoppingCartIcon" />
            </b-avatar>
            <div>
              <p class="mb-0 font-weight bold">{{ itemProd.NAME }}</p>
              <small>Cart</small>
            </div>
          </div>
        </router-link>
      </template>

      <div class="py-1 d-flex">
        <router-link
          v-tracker="'breadcumbs:total-cart'"
          :to="{
            name: 'product-calculator-total',
            params: { kode: $route.params.kode },
          }"
          class="d-flex text-body"
        >
          <b-avatar rounded size="40" :variant="activeClassTotal" class="mr-50">
            <feather-icon size="16" icon="CreditCardIcon" />
          </b-avatar>
          <div>
            <p class="mb-0 font-weight bold">Total</p>
            <small>Total Cart</small>
          </div>
        </router-link>
      </div>
      <div class="py-1 ml-2 d-flex">
        <b-button
          v-tracker="'button:add-product'"
          variant="primary"
          class="btn-icon"
          v-b-modal.assign-param
        >
          <feather-icon
            icon="PlusIcon"
            size="16"
          />
        </b-button>
      </div>
    </div>
    <div>
      <router-view />
    </div>
    <b-modal
      title="Add Product"
      hide-footer
      id="assign-param"
      centered
      hide-header-close
      no-close-on-backdrop
    >
      <b-form @submit.prevent="addProductCalc">
        <b-form-group label-for="product">
          <template slot="label">
            <span>Product <strong class="text-danger">*</strong></span>
          </template>
          <v-select
            v-model="selectedProduct"
            :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
            key="KODE"
            label="NAME"
            :options="optionProduct"
          />
        </b-form-group>
        <b-form-group class="d-flex justify-content-end">
          <b-button
            type="button"
            variant="light"
            class="mr-1"
            @click="$bvModal.hide('assign-param')"
          >
            Cancel
          </b-button>
          <b-button type="submit" variant="primary" @click="$bvModal.hide('assign-param')">
            Add
          </b-button>
        </b-form-group>
      </b-form>
    </b-modal>
    <b-modal
        ref="modal-request-access"
        centered
        title="Vertically Centered"
        :hide-footer="true"
        :hide-header="true"
        size="md"
      >
      <div class="d-flex flex-column align-items-center">
        <div class="align-self-end"> 
          <b-button
            v-ripple.400="'rgba(40, 199, 111, 0.15)'"
            variant="flat-secondary"
            class="btn-icon"
            size="md"
            @click="$refs['modal-request-access'].hide()"
          >
            <feather-icon icon="XIcon" />
          </b-button>
        </div>
        <div class="h2 text-danger mb-2">
          Kamu Tidak Mempunyai Hak Akses!
        </div>
      </div>
    </b-modal>
  </div>
</template>

<script>
import VSelect from 'vue-select'
import { BForm,BFormGroup, BModal, VBModal, BButton, BCard, BAvatar } from 'bootstrap-vue'
import { mapState,mapActions } from 'vuex'

export default {
  components: {
    VSelect,
    BForm,
    BFormGroup,
    BButton,
    BCard,
    BAvatar,
    BModal
  },

  directives: {
    VBModal
  },

  data() {
    return {
      product: {},
      optionProduct: [],
      selectedProduct: null,
      index : 0
    }
  },

  computed: {
    ...mapState('calculator', ['products']),
    canCalculator() {
      let permissions = this.$store.getters['oauth/getActiveUser'].permissions
      if (!permissions.includes('calculator_tarif')) {
        return false
      }
      return true
    },
    activeClass() {
      if (
        this.$route.name == 'product-calculator'
      ) {
        return 'danger'
      } else {
        return 'light-danger'
      }
    },
    activeClassTotal() {
      if (this.$route.name == 'product-calculator-total') {
        return 'danger'
      } else {
        return 'light-danger'
      }
    },
  },

  methods: {
    ...mapActions('calculator', ['addProduct']),
    addProductCalc() {
      console.log(this.selectedProduct);
      this.index = this.index + 1
      let newProd = {
        ID: this.selectedProduct.KODE,
        NAME: this.selectedProduct.NAME,
        INDEX: this.index,
        TYPE: [],
        TOTAL: 0,
        COUNT: 0
      }
      this.addProduct(newProd)
    },
    showModalNeedAccess() {
      this.$refs['modal-request-access'].show()
    },
  },

  created() {
    this.$http
      .get(`/product/id/${this.$route.params.kode}/set/first/published/true`)
      .then(response => {
        this.$store.commit(
          'app/SET_PAGE_TITLE',
          response.data.data.records.PRODUCT
        )
        if(this.products.length == 0){
          this.index = this.index + 1
          let prodObj = {
            ID: response.data.data.records.KODE,
            NAME: response.data.data.records.PRODUCT,
            INDEX: this.index,
            TYPE: [],
            TOTAL: 0,
            COUNT: 0
          }
          this.addProduct(prodObj)
          this.$router.push({query:{index:prodObj.INDEX}})
        }
      })

    this.$http
      .get(`/tarif`)
      .then(response => {
        this.optionProduct = response.data
      })
  },
  mounted() {
    // if (!this.canCalculator) {
    //   this.showModalNeedAccess()
    //   setTimeout( () => this.$router.push({ path: '/'}), 3000);
    // }
  }
}
</script>

<style>
.b-form-spinbutton.form-control .btn-sm, [dir] .b-form-spinbutton.form-control .btn-group-sm > .btn {
  background: red;
  color: white;
}
</style>

<style lang="scss">
@import '@core/scss/vue/libs/vue-select.scss';
</style>
